export function getUrlParameter(name: string) {
  // Default to empty string if called from command line
  if (typeof location === 'undefined') {
    return '';
  }
  const replaced = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp('[\\?&]' + replaced + '=([^&#]*)');
  const results = regex.exec(location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

// TODO can this be removed?
export function inDebugMode() {
  return getUrlParameter('debug') === 'true';
}

export function isScreenshotMode() {
  return getUrlParameter('screenshot') === 'true';
}

// TODO can this be removed?
export function isShareImgMode() {
  return getUrlParameter('shareImg') === 'true';
}
